export default __webpack_public_path__ + "static/media/collab_now.cf8b2296.png";